<template>
    <div>
        <div class="col-12  ">
            <span class="span-title">{{ $t('mvr_inspection.template_editor.section_header') }}</span>
            <input class="form-control form-control-mb" v-model="inspectionSectionTemplate.section_header" type="text" />
        </div>

        <hr />
        <h4 class="form-header px-2">{{ $t('mvr_inspection.template_editor.items') }}</h4>
        <draggable
            class="list-group"
            tag="ul"
            :list="inspectionSectionTemplate.inspectables"
            v-bind="dragOptions"
        >
            <transition-group type="transition" name="flip-list">
                <li
                    style="list-style: none"
                    v-for="element in inspectionSectionTemplate.inspectables"
                    :key="element.inspectable.id"
                >
                    <i :class="element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'"
                       @click="element.fixed = !element.fixed"
                       aria-hidden="true"
                    ></i>
                    <div class="d-flex justify-content-between align-items-center inspectables-ordered">
                        <span class="flex-grow-1">{{ element.inspectable.text }}</span>
                        <button class="btn btn-danger btn-sm" @click="updateInspectableSelection(element.inspectable)">
                            <i class="fa fa-times"/>
                        </button>
                    </div>
                </li>
            </transition-group>
        </draggable>
        <hr />
        <span class="span-title">
            {{ $t('mvr_inspection.template_editor.selectable_inspectables') }}
        </span>
        <div class="col-sm-12 row inspectable-container nopads mt-2">
            <div v-for="inspectable in inspectables" :key="inspectable.id"
                class="col-sm-6 col-md-4 col-lg-3 col-xl-2 inline inspectables nopads"
                :class="{ 'inspectables-disabled': isSelected(inspectable.id) }"
                @click="updateInspectableSelection(inspectable)">
                {{ inspectable.text }}
            </div>
        </div>
        <hr />
    </div>
</template>

<script>
import { restApi } from '@/components/mixins/RestApiMixin'
import { VueDraggableNext } from 'vue-draggable-next'

export default {
    name: 'MvrInspectionSectionEditor',
    components: { draggable: VueDraggableNext},
    mixins: [restApi],
    props: {
        section: {
            type: Object,
            default() {
                return {}
            }
        },
        inspectables: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data: function () {
        return {
            inspectionSectionTemplate: {
                id: null,
                section_header: '',
                inspectables: []
            }
        }
    },
    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: 'description',
                disabled: false,
                ghostClass: 'ghost',
            }
        },
    },
    watch: {
        inspectionSectionTemplate: {
            handler: function () {
                this.onMoveUpdate()
                this.$emit('updateSection', JSON.parse(JSON.stringify(this.inspectionSectionTemplate)))
            },
            deep: true
        }
    },
    created: function () {
        if (!!this.section && Object.keys(this.section).length > 0) {
            this.inspectionSectionTemplate.id = this.section.id || null
            this.inspectionSectionTemplate.section_header = this.section.section_header || ''
            this.inspectionSectionTemplate.inspectables = this.section.inspectables.map(x => JSON.parse(JSON.stringify(x)))
        }
    },
    methods: {
        isSelected: function (id) {
            return this.inspectionSectionTemplate.inspectables.some(x => x.inspectable.id === id)
        },
        onMoveUpdate() {
            // Update position
            this.inspectionSectionTemplate.inspectables.forEach((x, i) => {
                x.ordinal = i + 1
            })
        },
        updateInspectableSelection(inspectable) {
            const index = this.inspectionSectionTemplate.inspectables.findIndex(x => x.inspectable.id === inspectable.id)
            if (index !== -1) {
                this.inspectionSectionTemplate.inspectables.splice(index, 1)
            } else {
                this.inspectionSectionTemplate.inspectables.push({
                    inspectable: inspectable,
                    ordinal: this.inspectionSectionTemplate.inspectables.length + 1
                })
            }
        },
    }
}
</script>
